const Component = {
  "图片 url 不存在": "이미지 URL이 존재하지 않습니다.",
  "暂不支持下载此类型图片": "이 유형의 이미지는 현재 다운로드를 지원하지 않습니다."
}
  
export default Component;